import { Swiper } from 'swiper';
import { Pagination } from 'swiper/modules';

class Home {


  constructor() {
    this.swiperEvenementsPost();
    this.swiperAlerts();
    this.swiperPages();
  }

  private swiperEvenementsPost() {
    const swiperEl = document.querySelector('.home-evenements-actualites__swiper') as HTMLElement;
    if (swiperEl) {
      new Swiper(swiperEl, {
        direction: 'horizontal',
        slidesPerView: 'auto',
        spaceBetween: 16,
        breakpoints: {
          1025: {
            slidesPerView: 5,
          }
        }
      });
    }
  }

  private swiperAlerts() {
    const swiperEl = document.querySelector('.home-alerts__swiper') as HTMLElement;
    if (swiperEl) {
      new Swiper(swiperEl, {
        modules: [Pagination],
        direction: 'horizontal',
        slidesPerView: 'auto',
        spaceBetween: 24,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }
  }

  private swiperPages() {
    const swiperEl = document.querySelector('.home-pages__swiper') as HTMLElement;
    if (swiperEl) {
      new Swiper(swiperEl, {
        direction: 'horizontal',
        slidesPerView: 'auto',
        spaceBetween: 16,
      });
    }
  }
}

export const home = new Home();
